import React, {useRef, useState} from 'react';
import useCloseOnBlur from '../../../customHooks/useCloseOnBlur';
import cls from 'classnames';
import styles from './MobileMenu.module.scss';
import CustomLink from '../../UI/CustomLink';
import {useDispatch, useSelector} from 'react-redux';
import helpers from '../../../helpers/helpers';
import Submenu from './components/Submenu/Submenu';
import Link from 'next/link';
import authActions from '../../../store/actions/authActions';
import Router, {useRouter} from 'next/router';
import PROFILE from '../../../constants/profileConstants';
import useWindowDimensions from '../../../customHooks/useWindowDimensions';
import {breakpoints} from '../../../constants/breakpoints';

function MobileMenu({onOpenSearch}) {
  const [isOpen, setIsOpen] = useState(false);
  const {token} = useSelector((state) => state.auth);
  const username = useSelector((state) => state.auth.user?.name);
  const notifications = useSelector((state) => state.notifications.unreadNotificationsList);
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const dispatch = useDispatch();
  const router = useRouter();
  const {width} = useWindowDimensions();

  const {getTranslationText} = helpers;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsOpen(prev => !prev);
  };

  const handleClickMenu = (e) => {
    //check if clicked on free space of dropdown (space between button and content)
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const handleSignOut = (e) => {
    e.preventDefault();
    setIsOpen(false);
    dispatch(authActions.signOut());
  };

  const handleClickNotifications = () => Router.push({
    pathname: '/cabinet/profile',
    query: {page: PROFILE.NOTIFICATIONS},
    shallow: true
  });

  const handleClickSearch = (e) => {
    e.preventDefault();
    setIsOpen(false);

    if (typeof onOpenSearch === 'function') {
      onOpenSearch();
    }
  };

  useCloseOnBlur(wrapperRef, handleClose);

  return (
    <div className={styles.menu} ref={wrapperRef} onClick={handleClickMenu}>
      <button className={cls(styles.menuToggle, {[styles.active]: isOpen})} onClick={handleToggle}>
        <span/>
      </button>
      {isOpen && (
        <div className={styles.menuPopup} ref={contentRef}>
          <div className={styles.menuPopupInner}>
            {!!token && (
              <>
                <Submenu
                  titleText={username}
                  titleClassName={styles.menuLink}
                  content={
                    <div className={styles.menuSubmenu}>
                      <div onClick={handleToggle}>
                        <Link
                          href="/cabinet/balance"
                          as="/cabinet/balance"
                        >
                          <a className={styles.menuLink}>
                            {getTranslationText('header.profile_balance')}
                          </a>
                        </Link>
                      </div>
                      <button
                        className={styles.menuLink}
                        onClick={handleClickNotifications}
                      >
                        {getTranslationText('header.notify')}
                        <span className={styles.accent}>{notifications.length || 0}</span>
                      </button>
                      <div onClick={handleToggle}>
                        <Link
                          href="/cabinet/balance"
                          as="/cabinet/balance"
                        >
                          <a className={styles.menuLink}>
                            {getTranslationText('header.profile_balance')}
                          </a>
                        </Link>
                      </div>
                      <div onClick={handleToggle}>
                        <Link
                          href="/cabinet/gallery"
                          as="/cabinet/gallery"
                        >
                          <a className={styles.menuLink}>
                            {getTranslationText('header.profile_gallery')}
                          </a>
                        </Link>
                      </div>
                      <div onClick={handleToggle}>
                        <Link
                          href="/cabinet/deals"
                        >
                          <a className={styles.menuLink}>
                            {getTranslationText('header.profile_deals')}
                          </a>
                        </Link>
                      </div>
                      <div onClick={handleToggle}>
                        <Link
                          href="/cabinet/profile"
                          as="/cabinet/profile"
                        >
                          <a className={styles.menuLink}>
                            {getTranslationText('header.profile_profile')}
                          </a>
                        </Link>
                      </div>
                      <div onClick={handleToggle}>
                        <Link
                          href="/cabinet/support"
                        >
                          <a className={styles.menuLink}>
                            {getTranslationText('header.profile_support')}
                          </a>
                        </Link>
                      </div>
                      <div onClick={handleSignOut}>
                        <Link href="/">
                          <a
                            className={cls(styles.menuLink, styles.red)}>{getTranslationText('header.profile_signOut')}</a>
                        </Link>
                      </div>
                    </div>
                  }
                  defaultIsOpen
                />
              </>
            )}
            {width < breakpoints.sm && router.route !== '/search' && (
              <button className={styles.menuLink} onClick={handleClickSearch}>
                {getTranslationText('search.search') || 'Search'}
              </button>
            )}
            <a className={styles.menuLink} href="https://bit.team/">BIT.TEAM</a>
            <a className={styles.menuLink} href="https://bit.team/btt">TOKEN</a>
            {!!token && (
              <CustomLink href="/deposit/[id]" as="/deposit/del" className={styles.menuLink}>
                {getTranslationText('general.add_nft') || 'ADD NFT'}
              </CustomLink>
            )}
            {!token && (
              <a
                className={styles.menuAuthBtn}
                href={`${process.env.LOGIN_URL}`}
              >
                {getTranslationText('general.sign_in')}
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default MobileMenu;
